<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vcGIyC/tc-custom/9781488002984.jpg?1700958370237" alt="This image is the cover for the book Billionaire, Boss . . . Bridegroom?, Billionaires of London"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billionaire, Boss . . . Bridegroom?, Billionaires of London
      </h1>
      <p class="bookDescription body article font2">
        <p>The boss's proposal <br/><br/>Gorgeous, rich CEO Hugh Moncrieff might be his office's reluctant heartthrob, but he does not date employees! Until he needs a fake date for an upcoming engagement and decides his quirky new graphic designer Bella Faraday is the perfect candidate <br/><br/>Except Bella is anything but the unsuitable girlfriend she's supposed to be playing! Charming Bella's life might have been shattered by her ex, but with Hugh she feels all the pieces starting to fit back together</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Hardy
      </h2>
      
      <p class="authorDescription body article">Kate Hardy has been a bookworm since she was a toddler. When she isn&#39;t writing Kate enjoys reading, theatre, live music, ballet and the gym. She lives with her husband, student children and their spaniel in Norwich, England. You can contact her via her website: www.katehardy.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70e9cebf